import { EmailVerifiedPage } from "../../Components/EmailVerification/EmailVerifiedPage"

export const EmailVerification = () => {
    return (
        <EmailVerifiedPage/>
    )
}